import * as React from 'react';
import Select from 'react-select';

interface ISelectable<T> {
  id: T;
  name: string;
}

interface IOption<T> {
  label: string;
  value: T;
}

export const MultiselectFormControl = <T extends string | number>({
  disabled,
  className,
  placeholder,
  options: entries,
  selectedIDs,
  onChange,
}: {
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  options: Array<ISelectable<T>>;
  selectedIDs: T[];
  onChange(selectedIDs: T[]): void;
}) => {
  const options: Array<IOption<T>> = React.useMemo(
    () => entries.map((entry) => ({ value: entry.id, label: entry.name })),
    [entries],
  );
  const value = React.useMemo(() => {
    const selected = new Set<T>(selectedIDs);
    return options.filter((option) => selected.has(option.value));
  }, [options, selectedIDs]);

  return (
    <Select
      className={className}
      isMulti
      classNamePrefix="Select"
      options={options}
      value={value}
      onChange={(selections: any) => {
        onChange((selections as Array<IOption<T>>).map((option) => option.value));
      }}
      placeholder={placeholder}
      isDisabled={disabled}
    />
  );
};
